import { NeedsDomainDto } from '@act/shared/data-transfer-objects';
import { PaginatedTableProps } from '@act/storybook';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hooks';
import { NeedsDomainsTableColumns } from './NeedsDomainsColumns';
import { AdminToolSkeleton } from '../../AdminToolSkeleton';
import { IndexChildContainer } from 'react-components/member-index/indexContainer';
import { PaginatedTable } from '@act/storybook';
import { useMemo, useState } from 'react';
import { NeedsDomainCreateEdit } from './NeedsDomainCreateEdit';

export const NeedDomains = () => {
  const [domainEdit, setDomainEdit] = useState(false);
  const [domainCreate, setDomainCreate] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState<NeedsDomainDto | null>(
    null
  );
  const needs = metaSliceSelectors.useSelectNeedsMetadata().data;
  const columns = useMemo(() => {
    return NeedsDomainsTableColumns();
  }, [needs?.domains]);

  const NEEDS_DOMAINS_ADMIN_TABLE_PROPS: PaginatedTableProps<NeedsDomainDto> = {
    data: needs?.domains,
    columnConfig: columns,
    inMemoryPagination: true,
    onRowClick: (row: NeedsDomainDto) => {
      setSelectedDomain(row);
      setDomainEdit(true);
    },
  };

  const setFormOpen = (value: boolean) => {
    if (!value) {
      setDomainEdit(false);
      setSelectedDomain(null);
    }
  };
  return (
    <>
      <AdminToolSkeleton
        title="Needs Domains"
        toolDescription="Needs domains can be viewed and updated here."
        buttonContent="Add New Needs Domain"
        variant="contained"
        onClick={() => setDomainCreate(true)}
      >
        <IndexChildContainer>
          <PaginatedTable {...NEEDS_DOMAINS_ADMIN_TABLE_PROPS} />
        </IndexChildContainer>
      </AdminToolSkeleton>
      {(domainCreate || domainEdit) && (
        <NeedsDomainCreateEdit
          open={domainCreate || domainEdit}
          setOpen={domainCreate ? setDomainCreate : setFormOpen}
          isEdit={domainEdit}
          selectedDomain={selectedDomain}
        />
      )}
    </>
  );
};
